'use client';
import type { ReactElement } from 'react';
import HamburgerIcon from 'components/icons/HamburgerIcon';
import UIButton from 'components/buttons/UIButton';

export default function HamburgerButton({
  isOpen,
  toggleMenu,
  ariaControls,
}: {
  isOpen: boolean;
  toggleMenu: () => void;
  ariaControls: string;
}): ReactElement | null {
  return (
    <UIButton
      buttonType="text"
      className="open-menu-btn"
      onClick={toggleMenu}
      aria-expanded={isOpen}
      aria-controls={ariaControls}
      aria-label={'Open menu'}
      icon={<HamburgerIcon />}
      iconPosition="left"
      label={'Menu'}
    />
  );
}
